import { vocab } from '@/ds';

// Published events in the design system's words. Unpublished isn't a status here: an event taken
// out of the app leaves the catalog, so it isn't listed.

export const EVENT_TABS = ['live', 'past'] as const;
export type EventTab = (typeof EVENT_TABS)[number];

export const tabLabel = (tab: EventTab): string => vocab.STATUS.event?.[tab]?.label ?? tab;

const CATEGORY_ORDER: readonly string[] = vocab.CATEGORIES;
const rank = (category: string) => {
  const at = CATEGORY_ORDER.indexOf(category);
  return at < 0 ? CATEGORY_ORDER.length : at;
};

/** An event's race categories in the design system's order: 5K first, Other last. */
export const sortCategories = (categories: readonly string[]): string[] =>
  [...categories].sort((a, b) => rank(a) - rank(b));

/** A category in an address: "half-marathon". The API's values are the design system's words. */
export const categoryKey = (category: string): string =>
  category.toLowerCase().replace(/\s+/g, '-');

export const CATEGORY_KEYS: readonly string[] = CATEGORY_ORDER.map(categoryKey);

/** The design system's word, which is also the API's value; undefined for an unknown key. */
export const categoryFromKey = (key: string): string | undefined =>
  CATEGORY_ORDER.find((c) => categoryKey(c) === key);
